import { DISABLED_OPACITY as i } from "../../../styles/colors/consts.js";
function l(r, n, o, e) {
  const t = o || e === "normal" ? "underline" : "none";
  return r ? {
    textDecoration: t,
    fontWeight: e,
    cursor: "not-allowed",
    opacity: i
  } : n ? {
    textDecoration: t,
    fontWeight: e,
    webkitTapHighlightColor: "transparent"
  } : {
    textDecoration: t,
    fontWeight: e,
    hoverStyles: {
      textDecoration: "underline"
    },
    activeStyles: {
      textDecoration: "underline"
    },
    activeNavLinkStyles: {
      textDecoration: "underline"
    }
  };
}
export {
  l as default
};
